import React from 'react';

const Help = () => {
    return (
        <div className="space-y-6">
            <div className="border-b pb-4">
                <h3 className="text-lg font-semibold text-gray-800 mb-2">Expense Reports by Category</h3>
                <p className="text-sm text-gray-600">
                    Break down fleet expenditures by operational categories like Fuel, Maintenance, and Parts.
                </p>
            </div>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Cost Distribution</h4>
                <ul className="list-disc pl-5 space-y-2 text-sm text-gray-600">
                    <li><strong>Allocation:</strong> Understand where the majority of your budget is being spent.</li>
                    <li><strong>Optimization:</strong> Spot categories with unusually high expenses for potential cost-saving measures.</li>
                </ul>
            </section>

            <section>
                <h4 className="font-medium text-gray-700 mb-2">Interactive Table</h4>
                <p className="text-sm text-gray-600">
                    The report includes a detailed table where you can search through individual categorized transactions within your selected filters.
                </p>
            </section>
        </div>
    );
};

export default Help;
